export async function fetcher<T>(...args: Parameters<typeof fetch>) {
  return (await fetch(...args)).json() as T;
}
